export const FILTER_VALUES = {
  ASSIGNED_TO_ALL: 'assigned-to-all',
  ASSIGNED_TO_ME: 'assigned-to-me',
};

export const RESPONSE_FILTER_VALUES = {
  ALL: 'all',
  UNANSWERED: 'not-responded',
  ANSWERED: 'responded',
};
